<div class="form-group" *ngIf="!hideDefault" [formGroup]="filterCommonFormGroup">
  <mat-checkbox id="{{baseId}}-defualt-checkbox" formControlName="makeMyDefault" translate>
    Make My Default
  </mat-checkbox>
</div>
<div class="form-group" [formGroup]="filterCommonFormGroup">
  <label translate>Visible To</label>
  <mat-radio-group class="radio-group" formControlName="visibleTo">
    <mat-radio-button id="{{baseId}}-me" [value]="visitToEnum.Me" translate>Me Only</mat-radio-button>
    <mat-radio-button id="{{baseId}}-everyone" [value]="visitToEnum.Everyone" translate>Everyone</mat-radio-button>
  </mat-radio-group>
</div>

